import { HttpInterceptorFn } from '@angular/common/http';
import { catchError } from 'rxjs';
import { inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';

export const unauthorizedInterceptor: HttpInterceptorFn = (req, next) => {
   const authService = inject(AuthService);

   return next(req).pipe(
      catchError((error) => {
         if (error.status === 401) {
            authService.loginWithRedirect();
         }
         throw error;
      })
   );
};
